export default function DndScrooler({ scrollRefs }) {
  return null;
}
